// import $ from 'jquery';
import MpToast from '../../modules/components/toast.js';

// Export helpers to mpro namespace
mpro.showToast = MpToast.show.bind(MpToast);
mpro.getLastToast = MpToast.getLast.bind(MpToast);
mpro.getAllToasts = MpToast.getAll.bind(MpToast);
mpro.closeToast = MpToast.close.bind(MpToast);
mpro.closeAllToasts = MpToast.closeAll.bind(MpToast);

/**
 * @typedef {Partial<import('../../modules/components/toast.js').MpToastOptions & { timeout?: any; timeOut:? any; duration?: any; closeButton?: any; }>} MpCompatibleToastOptions
 */

const toastFormats = new Set(['primary', 'secondary', 'success', 'info', 'notice', 'warning', 'error']);

/**
 * Add wrapper for old call signature
 *
 * @param { MpCompatibleToastOptions['format'] | MpCompatibleToastOptions } format
 * @param { (string | MpCompatibleToastOptions)= } content
 * @param { MpCompatibleToastOptions } options
 */
mpro.toast = function(format, content, options = {}) {

	const defaultOptions = {
		// Custom option
		clearPrevErrors: true,
		clearPrev: false,
		...mpro.config.ui?.toast?.options,
	};

	// Shift arguments if format is not provided
	if (typeof format === 'object') {
		options = format;
		content = undefined;
		format = undefined;
	}

	options = (typeof content === 'string' || content instanceof Node)
		? { ...options, content }
		: { ...content, ...options };
	options = { ...defaultOptions, ...options };

	// Complete the options object
	if (typeof format === 'string') {
		options.format = format;
	}

	// Check deprecated usage of type
	if (options.type && toastFormats.has(options.type)) {
		// @ts-ignore
		options.format = options.type;
		delete options.type;
		console.warn('mpro.toast: "type" option is deprecated for specifying the style, use "format" instead');
	}

	// Normalize options
	if ('timeout' in options) {
		options.delay = options.timeout;
		delete options.timeout;
	}
	if ('timeOut' in options) {
		options.delay = options.timeOut;
		delete options.timeOut;
	}
	if ('duration' in options) {
		options.delay = options.duration;
		delete options.duration;
	}
	if ('closeButton' in options) {
		options.dismissible = options.closeButton;
		delete options.closeButton;
	}

	// Disable autohide
	if (options.delay === 0) {
		options.autohide = false;
	}

	// Unused
	// ========
	// if ('extendedTimeout' in options) {
	// 	options.extendedTimeOut = options.extendedTimeout;
	// }
	// // Normalize extendedTimeOut
	// if (('timeOut' in options) && !('extendedTimeOut' in options) && (options.timeOut > 0)) {
	// 	options.extendedTimeOut = options.timeOut / 2;
	// }

	// No duplicate notifications
	if (options.preventDuplicates) {
		/** @type {MpToast[]} */
		// @ts-ignore
		const toasts = MpToast.getAll().filter((toast) => {
			const vOpt = toast.getOptions();
			return (vOpt.type === options.type) && (vOpt.content === options.content) && (vOpt.title === options.title) && (vOpt.format === options.format);
		});

		// Clear errors
		if (toasts.length > 0) {
			for (const toast of toasts) {
				toast.close();
			}
		}
		delete options.preventDuplicates;
	}

	// Errors stay as long as needed
	if (format === 'error') {

		// Errors don't automatically hide
		options.autohide = (options.autohideError === true);

		if (options.clearPrevErrors) {
			/** @type {MpToast[]} */
			// @ts-ignore
			const toasts = MpToast.getAll().filter(toast => (toast.getOptions().format === 'error'));

			// Clear errors
			if (toasts.length > 0) {
				for (const toast of toasts) {
					toast.close();
				}
			}
		}
	}
	// Allow only 1 toast at a time
	else if (options.clearPrev) {
		mpro.clearToasts();
	}

	delete options.clearPrevErrors;
	delete options.clearPrev;

	// Set all timeouts to 0
	// if (options.timeOut == 0) {
	// 	options.extendedTimeOut = 0;
	// }

	// Display the notification
	return MpToast.show(options);
};

// Close toasts
mpro.clearToasts = function(filter = {}, withTransition = false) {
	MpToast.closeAll(filter, withTransition);
};

export default mpro;
